import { render, staticRenderFns } from "./NotificationTemplateTreatmentComposition.vue?vue&type=template&id=560f112f&scoped=true"
import script from "./NotificationTemplateTreatmentComposition.vue?vue&type=script&lang=js"
export * from "./NotificationTemplateTreatmentComposition.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplateTreatmentComposition.vue?vue&type=style&index=0&id=560f112f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f112f",
  null
  
)

export default component.exports